<template>
  <div class="px-4 pt-8 pb-14">
    <div class="d-flex flex-column">
      <span
        style="color: #000"
        class="pb-3"
      >Данные о пациенте:</span>
      <div
        class="d-flex flex-column px-5 py-3"
        style="border: 1px solid #24C4A3; border-radius: 40px"
      >
        <ul style="font-size: 16px; color: #2A3948">
          <li>{{ patientFio }}</li>
          <li>{{ patientBirthdateFormatted }}</li>
          <li>{{ patientPhoneFormatted }}</li>
          <li>{{ genderFilter(patientGender) }}</li>
        </ul>
      </div>

      <span
        style="color: #000"
        class="pt-8 pb-3"
      >Данные о записи:</span>
      <cumulative-info-panel />

      <div class="d-flex justify-center pt-14">
        <x-btn
          :ripple="false"
          color="#EB6E44"
          width="165"
          height="44"
          class="x-btn__primary"
          @click="onNewAppointmentClicked"
        >
          Новая запись
        </x-btn>
      </div>
    </div>
  </div>
</template>

<script>
import XBtn from "@/components/x-env/btn/XBtn"
import {mapGetters} from "vuex"
import NoteTooltip from '@/components/tooltip/NoteTooltip.vue'
import CumulativeInfoPanel from '@/components/panels/CumulativeInfoPanel.vue'
import {genderFilter} from '@/plugins/filters'

export default {
  components: {
    CumulativeInfoPanel,
    NoteTooltip,
    XBtn
  },
  computed: {
    ...mapGetters([
      'filialName',
      'doctorName',
      'doctorNote',
      'specialityFilterName',
      'serviceInfo',
      'scheduleInfo',
      'patientFio',
      'patientBirthdateFormatted',
      'patientPhoneFormatted',
      'patientGender'
    ]),
  },
  methods: {
    genderFilter,
    onNewAppointmentClicked() {
      window.location.reload()
    }
  }
}
</script>

<style scoped>

</style>